import { render } from "./ConfirmModal.vue?vue&type=template&id=6a7665c2"
import script from "./ConfirmModal.vue?vue&type=script&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/GenericComponents/ConfirmModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a7665c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a7665c2', __exports__)) {
    api.reload('6a7665c2', __exports__)
  }
  
  module.hot.accept("./ConfirmModal.vue?vue&type=template&id=6a7665c2", () => {
    api.rerender('6a7665c2', render)
  })

}


export default __exports__